@if (textContent()) {
  <div
    class="text-with-side-image flex pr-large-t"
    [ngClass]="{
      'black-friday': isBlackFriday(),
      'mr-large-b': noPadding(),
      'mr-large-y': !noPadding(),
      'no-padding': noPadding(),
      'pr-xlarge-t': !noPadding(),
      'pr-large-t': noPadding(),
      'text-with-side-image--reversed': imageLeft(),
    }"
  >
    <div class="text-with-side-image-article pr-xsmall-r">
      <cms-rich-text [content]="textContent()" />
      @if (link()) {
        <cms-link-block class="block pr-large-t" [content]="link()" />
      }
    </div>
    <div
      class="text-with-side-image-image pr-xsmall-l flex overflow-hidden"
      [ngClass]="{
        'disable-cropping flex--align-start': image()?.disableCropping,
        'flex--center': !noPadding(),
        'flex--start': noPadding(),
        'pr-xxsmall-t': noPadding(),
      }"
    >
      @if (image()) {
        <fin-content-image
          class="radius-medium"
          [imageData$]="image() | finToObservable"
          [aspectRatio$]="aspectRatio$"
          [fillParent]="isNewBrand() && !image().disableCropping"
        />
      }
    </div>
  </div>
}
